import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  theme: {
    themes: {
      light: {
        'red700': '#E04B48',
        'green700': '#43A047',

        primary: '#329988',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        dateandtimebg: "#B9E1DA",
        thePurple: '#7562A1',
        theGray: 'D9D9D9',
      },
      dark: {}
    }
  },
  icons: {
    iconfont: 'mdi',
  },
});
